import { RegisterImplementationProps } from 'constants/types';
import SignInBase from '../SignInBase';
import MainContainer from '../SignInMainContainer';
import LoaderButton from 'components/Button/LoaderButton';
import Input from 'components/Input/Input';
import PasswordInput from 'components/Input/PasswordInput';
import { credentialInstructions, getProviderFormLabel } from '../utils';
import { SwitchImplementationButton } from 'components/LinkButton/LinkButton';

const SignInJustworksCredential = ({
  isLoading,
  onSubmit,
  client,
  provider,
  handleClick,
}: RegisterImplementationProps) => {
  const instructions = credentialInstructions(client);

  return (
    <SignInBase
      formLabel={getProviderFormLabel(provider)}
      instructions={instructions}
      onSubmit={onSubmit}
      fieldNames={['username', 'password']}
      render={({ username, password }) => {
        return (
          <>
            <MainContainer useNewDesign>
              <Input
                value={username.value}
                onChange={(event) => username.onChange(event.target.value)}
                invalid={username.invalid}
                label="Username"
                id="username"
              />
              <PasswordInput
                reset={{
                  uri: new URL('https://login.justworks.com/'),
                  providerDisplayName: provider.displayName,
                }}
                value={password.value}
                onChange={(event) => password.onChange(event.target.value)}
                invalid={password.invalid}
              />
            </MainContainer>
            {handleClick && (
              <SwitchImplementationButton onClick={handleClick} useNewDesign>
                Authenticate through Justworks
              </SwitchImplementationButton>
            )}
            <LoaderButton
              isLoading={isLoading}
              disabled={isLoading || !username.value || !password.value}
              type="submit"
              text="Connect"
            />
          </>
        );
      }}
    />
  );
};

export default SignInJustworksCredential;
